/**
* 基础菜单 快递邮费管理
*/
<template>
  <div class="contianer">
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item>
        <el-button size="small" type="primary" @click="addData" class="add-button">新增</el-button>
        <el-button size="small" type="primary" @click="editData" class="edit-button">修改</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <div style="height: 530px;overflow-y: auto">
      <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                @cell-dblclick="cellDbClick" @selection-change="handleSelectionChange"
                :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                element-loading-text="拼命加载中"  style="width: 70%;">
        <el-table-column align="center" type="selection" width="60">
        </el-table-column>
        <el-table-column
          label="序号"
          width="60">
          <template slot-scope="scope">
            {{pageparm.pageSize * (pageparm.currentPage - 1) + (scope.$index + 1)}}
          </template>
        </el-table-column>
        <el-table-column prop="free_delivery_money" label="订单包邮金额" width="200">
        </el-table-column>
        <el-table-column prop="remote_delivery_fee" label="偏远地区邮费" width="180">
        </el-table-column>
        <el-table-column prop="non_remote_delivery_fee" label="非偏远地区邮费" width="200">
        </el-table-column>
        <el-table-column prop="remote_province" label="偏远地区" min-width="200" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="status" label="有效状态" width="100">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              :active-value="1"
              :inactive-value="0"
              @change="changeStatus(scope.row.id,scope.row.status)"
              active-color="#409EFF">
            </el-switch>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               :title="dialogTitle"
               :visible.sync="addDialogVisible"
               width="30%"
               :before-close="handleClose"
               center>
      <el-form label-width="155px" :model="addForm" :rules="addRules" ref="addForm" class="attrForm">
        <el-form-item label="订单包邮金额" prop="free_delivery_money" class="relative r50">
          <el-input size="small" v-model="addForm.free_delivery_money" auto-complete="off" clearable maxlength="8"
                    placeholder="请输入订单包邮金额"></el-input>
        </el-form-item>
        <el-form-item label="偏远地区邮费" prop="remote_delivery_fee" class="relative r50">
          <el-input size="small" v-model="addForm.remote_delivery_fee" auto-complete="off" clearable maxlength="8"
                    placeholder="请输入偏远地区邮费"></el-input>
        </el-form-item>
        <el-form-item label="非偏远地区邮费" prop="non_remote_delivery_fee" class="relative r50">
          <el-input size="small" v-model="addForm.non_remote_delivery_fee" auto-complete="off" clearable maxlength="8"
                    placeholder="请输入非偏远地区邮费"></el-input>
        </el-form-item>
        <el-form-item label="偏远地区" prop="remote_province_ids" class="relative r50">
          <el-select v-model="addForm.remote_province_ids" multiple collapse-tags placeholder="请选择偏远地区" clearable>
            <el-option v-for="province in provinceList" :key="province.code" :label="province.name"
                       :value="province.code"></el-option>
          </el-select>
          <div class="idstext">*全国其他省份/地区将全部视为非偏远地区</div>
        </el-form-item>
        <el-form-item label="有效状态" prop="status">
          <el-select v-model="addForm.status" placeholder="请选择有效状态" clearable>
            <el-option v-for="item in statusList" :key="item.value" :label="item.name"
                       :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="saveForm('addForm')" :disabled="!isCanSubmit">保存</el-button>
            <el-button @click="handleClose()">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  deliveryConfigList,
  deliveryConfigAdd,
  deliveryConfigUpdate,
  deliveryConfigDetail,
  deliveryConfigUpdateStatus
} from '../../api/basisMG'
import Pagination from '../../components/Pagination'
import {locationArea} from "../../api/commonMG";

export default {
  data: () => {
    var validateNum = (rule, value, callback) => {
      if (value === '' || value == undefined || value == null) {
        return callback(new Error('请输入排序号'));
      } else if (!(/(^[1-9]\d*$)/.test(value))) {
        return callback(new Error('请输入正整数'));
      } else {
        return callback();
      }
    };
    var validatePriceMoney = (rule, value, callback) => {
      if (value === '' || value == undefined || value == null) {
        return callback(new Error('请输入订单包邮金额'));
      } else if (!(/(^0\.[1-9]\d?$)|(^0\.\d[1-9]?$)|(^[1-9]\d{0,7}(\.\d{0,2})?$)/.test(value)) && value != '' && value != undefined) {
        return callback(new Error('输入长度过长或格式不正确'));
      } else {
        return callback();
      }
    };
    var validatePriceFee = (rule, value, callback) => {
      if (value === '' || value == undefined || value == null) {
        return callback(new Error('请输入偏远地区邮费'));
      } else if (!(/(^0\.[1-9]\d?$)|(^0\.\d[1-9]?$)|(^[1-9]\d{0,7}(\.\d{0,2})?$)/.test(value)) && value != '' && value != undefined) {
        return callback(new Error('输入长度过长或格式不正确'));
      } else {
        return callback();
      }
    };
    var validatePriceNon = (rule, value, callback) => {
      if (value === '' || value == undefined || value == null) {
        return callback(new Error('请输入非偏远地区邮费'));
      } else if (!(/(^0\.[1-9]\d?$)|(^0\.\d[1-9]?$)|(^[1-9]\d{0,7}(\.\d{0,2})?$)/.test(value)) && value != '' && value != undefined) {
        return callback(new Error('输入长度过长或格式不正确'));
      } else {
        return callback();
      }
    };
    return {
      loading: false, //是显示加载
      addDialogVisible: false,  // 弹窗
      setRoleDialogVisible: false,  // 弹窗
      dialogTitle: '',  // 标题
      selectTableData: [],
      id: '',
      productOptions: [],
      productOptionsHome: [],
      formInline: {
        page: 1,
        rows: 10,
      },
      addRules: {
        free_delivery_money: [{required: true, validator: validatePriceMoney, trigger: 'blur'}],
        remote_delivery_fee: [{required: true, validator: validatePriceFee, trigger: 'blur'}],
        non_remote_delivery_fee: [{required: true, validator: validatePriceNon, trigger: 'blur'}],
        remote_province_ids: [{required: true, message: '请选择偏远地区', trigger: 'change'}],
        status: [{required: true, message: '请选择状态', trigger: 'change'}]
      },
      addForm: {
        id: "",
        free_delivery_money: '',
        remote_delivery_fee: '',
        non_remote_delivery_fee: '',
        remote_province_ids: [],
        status: ''
      },
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      isCanSubmit: true,
      name: '',
      options: [],
      provinceList: [],
      statusList: [{
        name: '有效',
        value: 1
      }, {
        name: '无效',
        value: 0
      }],
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 创建完毕
   */
  created() {
    this.getData(this.formInline)
    this.getLocationArea()
  },
  methods: {
    getLocationArea() {
      let pid = ''
      locationArea(pid).then(res => {
        if (res.success == false) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          this.provinceList = res.content
        }
      }).catch(err => {
        this.$message.error('网络错误，请稍后再试！')
      })
    },
    // 新增快递邮费
    addData() {
      this.addDialogVisible = true;
      this.dialogTitle = '新增快递邮费';
      this.addForm = {
        id: "",
        free_delivery_money: '',
        remote_delivery_fee: '',
        non_remote_delivery_fee: '',
        remote_province_ids: [],
        status: ''
      };
    },
    // 修改快递邮费
    editData() {
      if (this.selectTableData.length == 0) {
        this.$message.error('请选择一条数据再操作!');
        return
      }
      if (this.selectTableData.length > 1) {
        this.$message.error('当前操作只能选择一条数据!');
        return
      }
      this.dialogTitle = '修改快递邮费';
      this.addDialogVisible = true;
      deliveryConfigDetail(this.selectTableData[0].id)
        .then(res => {
          if (res.success) {
            this.addForm = res.content;
            this.addForm.remote_province_ids = this.addForm.remote_province_ids.map(Number)
          }
        })
        .catch(err => {
        })
      this.id = this.selectTableData[0].id;
    },
    // 获取公司列表
    getData(parameter) {
      this.loading = true
      deliveryConfigList(parameter)
        .then(res => {
          this.loading = false
          if (res.success == false) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.content.rows
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.rows
            this.pageparm.total = res.content.total
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('网络错误，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.rows = parm.pageSize
      this.getData(this.formInline)
    },
    // 新增快递邮费
    saveForm(formName) {
      if (this.dialogTitle == '修改快递邮费') {
        this.addForm.id = this.id;
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isCanSubmit = false;
          this.loading = true;
          if (this.dialogTitle == '新增快递邮费') {
            deliveryConfigAdd(this.addForm)
              .then(res => {
                this.isCanSubmit = true;
                this.loading = false
                if (res.success == false) {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                } else {
                  this.$message({
                    type: 'success',
                    message: '您已成功增加快递邮费!'
                  });
                  this.handleClose()
                  this.getData(this.formInline)
                }
              })
              .catch(err => {
                this.isCanSubmit = true;
                this.loading = false
                this.$message.error('网络错误，请稍后再试！')
              })
          } else {
            deliveryConfigUpdate(this.addForm)
              .then(res => {
                this.isCanSubmit = true;
                this.loading = false
                if (res.success == false) {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                } else {
                  this.$message({
                    type: 'success',
                    message: '您已成功修改快递邮费!'
                  });
                  this.handleClose()
                  this.getData(this.formInline)
                }
              })
              .catch(err => {
                this.isCanSubmit = true;
                this.loading = false
                this.$message.error('网络错误，请稍后再试！')
              })
          }
        } else {
          console.log('error submit!!');
        }
      });
    },
    // 搜索事件
    search() {
      this.formInline.page = 1;
      this.getData(this.formInline)
    },
    handleRemove(file) {
      console.log(file);
    },
    handleSelectionChange(val) {
      this.selectTableData = val
    },
    handleClose() {
      this.$refs["addForm"].resetFields();
      this.addDialogVisible = false;
    },
    // 状态
    changeStatus(id, status) {
      const params = {
        id: id,
        status: status
      };
      console.log(params)
      deliveryConfigUpdateStatus(params)
        .then(res => {
          if (res.success == false) {
            this.$message({
              type: 'info',
              message: res.msg
            });
          } else {
            this.$message({
              type: 'success',
              message: '有效状态修改成功！'
            });
            this.getData(this.formInline)
          }
        })
        .catch(err => {
          this.$message.error('网络错误，请稍后再试！');
        });
    },
    //双击复制
    cellDbClick(row, column, cell, event) {
      if (row.attr_name == cell.innerText) {
        if (event.type === "dblclick") {
          var save = function (e) {
            e.clipboardData.setData('text/plain', cell.innerText);
            e.preventDefault();//阻止默认行为
          }
          document.addEventListener('copy', save);
          document.execCommand("copy");
          document.removeEventListener('copy', save);
        }
        this.$message({message: '复制成功', type: 'success'})
      }
    }
  }
}
</script>

<style scoped>
  .contianer {
    background: #fff;
    padding: 20px;
  }

  /deep/ .user-search .el-input__inner {
    height: 40px;
    line-height: 40px;
  }

  /deep/ .user-search .el-form-item {
    margin-bottom: 10px;
  }

  /deep/ .user-search .el-button--small {
    height: 40px;
  }

  /deep/ .textarea .el-textarea__inner {
    resize: none;
  }

  /deep/ .r55 .el-input__suffix {
    right: 55px !important;
  }

  .breadcrumb {
    margin-bottom: 15px;
  }

  /deep/ .attrForm .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 320px;
  }

  /deep/ .attrForm .el-input {
    width: 320px;
  }

  /deep/ .attrForm .el-input--small {
    width: 320px;
  }

  /deep/ .textarea .el-textarea__inner {
    resize: none;
  }

  /deep/ .attrForm .el-form-item__label {
    position: relative;
    padding: 0 22px 0 0 !important;
  }

  /deep/ .attrForm .el-select-dropdown__list {
    padding-bottom: 50px;
    min-height: 150px;
  }

  /deep/ .attrForm .el-select-dropdown__item {
    width: 320px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  /deep/ .attrForm .el-input--small {
    width: 320px;
  }

  /deep/ .pswd .el-input__inner {
    padding-right: 135px;
  }

  .add-button {
    background: #53B03C;
    border-color: #53B03C;
  }

  .edit-button {
    background: #58B7D6;
    border-color: #58B7D6;
  }

  .pagination-absolute {
    position: absolute;
    bottom: 0;
    background: #fff;
    width: 95%;
    padding-left: 20px;
    height: 40px;
  }

  /deep/ .el-dialog--center {
    border-radius: 8px !important;
  }

  /deep/ .el-message-box__title {
    color: #409EFF !important;
  }

  /deep/ .el-dialog__title {
    color: #409EFF !important;
  }

  .idstext {
    font-size: 11px;
    color: #d9001b;
  }

</style>





// WEBPACK FOOTER //
// src/views/store/expressFee.vue